import { Button, Modal, Space, Tag, Timeline, Tooltip } from "antd"
import CloseIcon from "../../../components/icons/CloseIcon";
import FileIconSmall from "../../../components/icons/FileIconSmall";
import EyeIcon from "../../../components/icons/EyeIcon";
import DownloadIcon from "../../../components/icons/DownloadIcon";
import { DATE_FORMAT_DD_MM_YYYY, STATUS_CANCELLED, STATUS_COMPLETED, STATUS_PENDING, STATUS_REQUESTED, USER_TYPE_PARTNER } from "../../../constants/constants";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import PdfViewerModal from "../../components/Modal/PdfViewerModal";
import Detailltem from "../../Organization/components/Detailltem";
import { getBrandAdvisoryReportbyId, getPartnerAdvisoryReportbyId } from "../../../API/endpoints/Advisory";

interface Props {
    data: any;
    isPartner: boolean
    onClose: () => void;
}
const ReportInfoModal = (props: Props) => {
    const { data, isPartner } = props;

    const [pdfData, setPdfData] = useState<any>({});
    const [logs, setLogs] = useState<any[]>([]);

    useEffect(() => {
        if (data?.id) {
            console.log('isPartner', isPartner);

            if (isPartner) {
                getPartnerAdvisoryReportbyId(data?.id).then((res: any) => {
                    setLogs(res?.data?.partner_advisory_logs || [])
                }).catch((err) => {
                    console.error('err', err);
                    setLogs([])
                })
            } else {
                getBrandAdvisoryReportbyId(data?.id).then((res: any) => {
                    setLogs(res?.data?.brand_advisory_logs || [])
                }).catch((err) => {
                    console.error('err', err);
                    setLogs([])
                })
            }

        }

    }, [data])
    const downloadFile = (path: string) => {
        window.open(path, "_blank");
    };

    const onClose = () => {
        props.onClose();
        setLogs([]);
    }


    const logList: any = useMemo(() => {
        return logs?.map((log: any) => ({
            children: (<div key={log?.id} >
                <div className="flex gap-x-[4px]">
                    <p className="text-[12px] text-[#475467] m-0">{log?.log_type} Date:</p>
                    <p className="text-[12px] font-[500] m-0">{dayjs(log?.log_date)?.format(DATE_FORMAT_DD_MM_YYYY)}</p>
                </div>
                <div className="flex gap-x-[4px]">
                    <p className="text-[12px] text-[#475467] m-0">{log?.log_type} By:</p>
                    <p className="text-[12px] font-[500] m-0">{log?.User?.first_name} {log?.User?.last_name}</p>
                </div>
            </div>
            )
        }))
    }, [logs])

    const marketsList = useMemo(() => {
        return data?.markets?.map((m: string, index: number) => {
            return <Tag color="default" bordered={false} key={index}>{m}</Tag>
        })
    }, [data])

    return (
        <Modal
            open={data && Object.keys(data)?.length > 0}
            title={(
                <div className="flex justify-between items-center">
                    <p className="capitalize text-[14px] font-[500] m-0">Info</p>
                    <Button type="text" icon={<CloseIcon />} className="leading-[12px]" onClick={() => onClose()} />
                </div>
            )
            }
            onCancel={() => onClose()}
            footer={false}
            closeIcon={false}
            width={500}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !py-[10px]",
                body: "!p-[20px] flex flex-col gap-y-[20px]"
            }}
            centered
        >
            <div className="max-h-[400px] overflow-auto flex flex-col gap-y-[16px]">
                <div className="flex items-center gap-x-[20x] justify-between">
                    <Detailltem
                        label={data?.Brand?.brand_name ? "Brand" : "Partner"}
                        value={data?.Brand?.brand_name || data?.Partner?.name}
                    />
                    {
                        <Tag
                            bordered={false}
                            color={data?.status === STATUS_COMPLETED ? "success" : data?.status === STATUS_CANCELLED ? "error" : "warning"}
                            className="rounded-[16px] capitalize"
                        >
                            {data?.status?.toLowerCase()}
                        </Tag>
                    }
                </div>

                <div className="grid grid-cols-2 gap-x-[16px]">
                    <Detailltem
                        label="Report Sub Type"
                        value={data?.report_sub_type}
                    />
                    {data?.file_name ? (
                        <Detailltem
                            label="Document / File Name"
                            value={data?.file_name}
                        />
                    ) : (
                        <></>
                    )}

                </div>

                <div>
                    <p className="text-[12px] text-[#475467] mb-[4px]">Markets</p>
                    <div className="flex gap-y-[4px] flex-wrap">
                        {marketsList}
                    </div>
                </div>

                <Detailltem
                    label="Description"
                    value={data?.description || ""}
                />

                {
                    data?.path ? (
                        <div className="w-full">
                            <p className="text-[12px] text-[#475467] mb-[4px]">Uploaded File</p>
                            <div className="flex gap-x-[8px] items-center w-full border border-[#E4E7EC] rounded-[8px] p-[8px]">
                                <FileIconSmall />
                                <p className="m-0 text-[12px] leading-[12px] flex-1">{data?.file_name}</p>
                                <Button type="text" size="small" icon={<EyeIcon />} className="bg-[#EDEDED]" onClick={() => setPdfData({ path: data?.path, name: data?.file_name })} />
                                <Button type="text" size="small" icon={<DownloadIcon />} className="bg-[#EDEDED]" onClick={() => downloadFile(data?.path)} />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
                <div>
                    <Timeline
                        items={logList}
                    />
                </div>

                <PdfViewerModal
                    pdfData={pdfData}
                    isPdfOpen={Object.keys(pdfData).length > 0}
                    closeModal={() => setPdfData({})}
                />
            </div>
        </Modal>
    )
}

export default ReportInfoModal